"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollToIframe = void 0;
const react_1 = require("react");
const app_parameters_1 = require("@pulse-web-platform-core/app-parameters");
const useScrollToIframe = () => {
    const { isIframe } = (0, app_parameters_1.useConfig)();
    return (0, react_1.useCallback)(() => {
        if (isIframe)
            return window.parent.postMessage({ action: 'scrollToIframe' }, '*');
        const iframeObj = document.getElementById('pulseRoot');
        window.scrollTo({
            top: iframeObj.offsetTop,
            behavior: 'smooth',
        });
    }, [isIframe]);
};
exports.useScrollToIframe = useScrollToIframe;
